document.addEventListener("DOMContentLoaded", function () {
  // Botones para eliminar del carrito
  const deleteButtons = document.querySelectorAll("form[action='/cart/change']");

  deleteButtons.forEach(function (form) {
    form.addEventListener("submit", function (e) {
      e.preventDefault();

      const formData = new FormData(form);
      fetch("/cart/change.js", {
        method: "POST",
        body: formData,
      })
        .then((response) => {
          if (response.ok) {
            window.location.reload();
          } else {
            alert("No se pudo actualizar el carrito.");
          }
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    });
  });
});
